import styled, { CSSObject } from 'styled-components';
import { FrameHeaderHeight } from 'styles/constants';

interface DialogStyledProps {
  fullHeight: boolean;
  fullWidth: boolean;
  desktopMode?: boolean;
  sx?: CSSObject;
}

const DialogStyled = styled.div<DialogStyledProps>(
  ({ theme, fullWidth, fullHeight, sx, desktopMode = false }) => {
    const styleSheet: CSSObject = {
      background: theme.color.wfWhite,
      boxSizing: 'border-box',
      position: 'absolute',
      height: `calc(100% - ${desktopMode ? 0 : FrameHeaderHeight}px)`,
      overflow: 'auto',
      zIndex: 99999,
      ...sx,
    };

    if (fullWidth) {
      styleSheet.width = '100%';
    }

    if (fullHeight) {
      styleSheet.height = '100%';
    }

    return styleSheet;
  },
);

export { DialogStyled };
